import { useRouter, useSearchParams } from "next/navigation";
import $filters from "@/data/filters.constants";
import { useEffect, useState } from "react";
import useModelsData from "@/components/pages/home/hooks/use-models-data";
import { useCategoriesDropdownContext } from "@/components/pages/home/providers/categories-dropdown-provider";
import { useVoiceCardHandler } from "@/components/pages/convert/hooks/use-voice-card-handler";
import { useScroller } from "@/hooks/use-scroller";
import { useGenderDropdownContext } from "@/components/pages/home/providers/gender-dropdown-provider";

export const useVoiceSelect = () => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const categoryFilters = $filters.modelFilters;
  const genderFilters = $filters.genderFilters;

  const { scrollY, scrollUpdate } = useScroller();

  const {
    searchValue,
    handleFilterSelect,
    handleGenderSelect,
    ...modelsProps
  } = useModelsData();

  const { setValue: setCategory } = useCategoriesDropdownContext();
  const { setValue: setGender } = useGenderDropdownContext();

  const { handleDefaultVoiceModelClick } = useVoiceCardHandler();

  // load initial filter from url
  const applyFilter = (
    paramName: string,
    filterList: typeof genderFilters | typeof categoryFilters,
    setter: (value: any) => void,
    filterHandler: (filter: any) => void,
  ) => {
    const paramValue = searchParams.get(paramName);
    if (!paramValue) return;

    const decodedValue = decodeURIComponent(paramValue).toLowerCase();
    const foundFilter = filterList.find(
      (f) => f.category.toLowerCase() === decodedValue,
    );

    if (foundFilter) {
      setter(foundFilter);
      filterHandler(foundFilter);
    } else {
      router.push("/");
    }
  };

  // Завантаження початкових параметрів
  useEffect(() => {
    applyFilter("category", categoryFilters, setCategory, handleFilterSelect);
    applyFilter("gender", genderFilters, setGender, handleGenderSelect);
  }, []);

  return {
    scrollY,
    searchValue,
    handleFilterSelect,
    handleDefaultVoiceModelClick,
    handleGenderSelect,
    scrollUpdate,
    ...modelsProps,
  };
};
